export enum SCREENS {
    EXERCISES = 'KduC2sDaKegAVDzlAlfv',
    RELAX = '3ebJHAQpwyOibmxgUISw',
    PLAYGROUND = 'DLOBrtNWXXuPwCWcpYXu',
}
